import { Grid, Tab, Tabs, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../../components/PageHeader";
import { useState } from "react";
import { GoogleQueryList } from "./GoogleQueryList";
import { GoogleTouchPointsList } from "./GoogleTouchPointsList";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export function GoogleManagementPage() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const [currentTab, setCurrentTab] = useState("query");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  var currentPage = <div></div>;
  if (currentTab == "query") {
    currentPage = <GoogleQueryList />;
  }
  if (currentTab == "touch_points_journey") {
    currentPage = <GoogleTouchPointsList />;
  }
  return (
    <TrendzContainerCard title={t("social:google_queries")}>
      <Tabs value={currentTab} onChange={handleChangeTab}>
        <Tab
          label={
            <Tooltip title={t("social:query")}>
              <div>{t("social:query")}</div>
            </Tooltip>
          }
          value="query"
        ></Tab>
        <Tab
          label={
            <Tooltip title={t("social:touch_points_journey")}>
              <div>{t("social:touch_points_journey")}</div>
            </Tooltip>
          }
          value="touch_points_journey"
        ></Tab>
      </Tabs>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={10.5} className="white"></Grid>
      <Grid item xs={0.75} />
      <Grid item xs={0.75} />
      <Grid item xs={10.5} marginTop={3}>
        {currentPage}
      </Grid>
      <Grid item xs={0.75} />
    </TrendzContainerCard>
  );
}
